module.exports = __webpack_public_path__ + "img/france-diabetes-mellitus-female.43042bc2.png";